import { API_ORGANIZATION } from "globals/constants";
import { spUrl } from "utils";
import { buildSearchParams, request } from "utils/proxy";


export const organization = {
	/**
	 * @param {{ id: string }} params
	 * @param {{}?} options
	 */

	get: (params, options) => request(spUrl(`${API_ORGANIZATION}/${params.id}`), options),

	/**
	 * Retrieve a list of organizations.
	 *
	 * @param {object} params - Query parameters for filtering and pagination.
	 * @param {{}?} options - Request options.
	 * @param {number} [params.page] - The page number for pagination.
	 * @param {number} [params.size] - The number of items per page.
	 * @param {string[]} [params.search] - A search term for filtering.
	 *
	 * @returns {Promise<{}[]>} A Promise that resolves with the list of organizations.
	 */
	findAll: (params, options) => request(spUrl(`${API_ORGANIZATION}${buildSearchParams(params)}`), options),
};
